module.exports = __webpack_public_path__ + "img/remove_account_1.5a960b57.png";